import styled from 'styled-components';
import theme from './theme';
const { colors, fontSizes, shadows } = theme;

export const Input = styled.input`
	padding: ${props => props.padding};
	font-size: ${props => props.fontSize || theme.fontSizes[5]};
	border: ${props => props.border || 'none'};
	background: ${props => props.background};
	color: ${props => props.color};
	width: ${props => props.width || '100%'};
	border-radius: ${props => props.borderRadius};
	margin-bottom: ${props => props.marginBottom};
	margin-top: ${props => props.marginTop};
	outline: ${props => props.outline};
`;

export const Button = styled.button`
	color: ${props => props.color || 'white'};
	float: ${props => props.float || 'right'};
	font-weight: ${props => props.fontWeight || 'bold'};
	font-size: ${props => props.fontSize || fontSizes[6]};
	background: ${props => props.background || colors.cornflower};
	border: ${props => props.border || 'none'};
	padding: ${props => props.padding || '10px 14px'};
	border-radius: ${props => props.borderRadius || '4px'};
	opacity: ${props => props.opacity};
	cursor: ${props => props.cursor};
	outline: ${props => props.outline};
	margin-left: ${props => props.marginLeft};
`;

export const Container = styled.div`
	width: 100%;
	height: 100%;
	background-color: ${colors.containerBackground};
	padding: ${props => props.p};
	padding-top: ${props => props.pt};
	padding-bottom: ${props => props.pb};
	padding-left: ${props => props.pl};
	padding-right: ${props => props.pr};
	position: ${props => props.position};
`;

export const FlexBox = styled.div`
	display: flex;
	flex: ${props => props.flex};
	flex-direction: ${props => props.flexDirection || 'row'};
	flex-wrap: ${props => props.flexWrap};
	flex-flow: ${props => props.flexFlow};
	flex-shrink: ${props => props.flexShrink};
	align-items: ${props => props.alignItems};
	justify-content: ${props => props.justifyContent};
	align-content: ${props => props.alignContent};
	width: ${props => props.width};
	max-width: ${props => props.maxWidth};
	height: ${props => props.height};
	min-height: ${props => props.minHeight};
	position: ${props => props.position};
	margin-bottom: ${props => props.marginBottom};
	margin-left: ${props => props.marginLeft};
	margin-right: ${props => props.marginRight};
	margin-top: ${props => props.marginTop};
	margin: ${props => props.margin};
	padding: ${props => props.padding};
	padding-left: ${props => props.paddingLeft};
	padding-bottom: ${props => props.paddingBottom};
	color: ${props => props.color};
	font-size: ${props => props.fontSize};
	font-weight: ${props => props.fontWeight};
	line-height: ${props => props.lineHeight};
	text-align: ${props => props.textAlign};
	white-space: ${props => props.whiteSpace};
	border-bottom: ${props => props.borderBottom};
	border-radius: ${props => props.borderRadius};
	box-shadow: ${props => props.boxShadow};
	background: ${props => props.background};
	background-color: ${props => props.backgroundColor};
	word-break: ${props => props.wordBreak};
	stroke: ${props => props.stroke};
	overflow: ${props => props.overflow};
`;
export const FixedPosition = styled.div`
	position: fixed;
`;

export const AbsolutePosition = styled.div`
	position: absolute;
	top: ${props => props.top};
	right: ${props => props.right};
	bottom: ${props => props.bottom};
	left: ${props => props.left};
`;

export const Text = styled.div`
	font-size: ${props => props.fontSize};
	font-weight: ${props => props.fontWeight};
	font-style: ${props => props.fontStyle};
	color: ${props => props.color};
	cursor: ${props => props.cursor};
	line-height: ${props => props.lineHeight};
	letter-spacing: ${props => props.letterSpacing};
	text-align: ${props => props.textAlign};
	padding-bottom: ${props => props.paddingBottom};
	margin: ${props => props.margin};
	margin-bottom: ${props => props.marginBottom};
	max-width: ${props => props.maxWidth};
`;

export const Box = styled.div`
	display: ${props => props.display};
	align-items: ${props => props.alignItems};
	justify-content: ${props => props.justifyContent};
	flex: ${props => props.flex};
	flex-shrink: ${props => props.flexShrink};
	flex-basis: ${props => props.flexBasis};
	position: ${props => props.position};
	z-index: ${props => props.zIndex};
	background: ${props => props.background};
	background-color: ${props => props.backgroundColor};
	border-radius: ${props => props.borderRadius};
	margin: ${props => props.margin};
	margin-top: ${props => props.marginTop};
	margin-right: ${props => props.marginRight};
	margin-bottom: ${props => props.marginBottom};
	margin-left: ${props => props.marginLeft};
	padding: ${props => props.padding};
	padding-top: ${props => props.paddingTop};
	padding-left: ${props => props.paddingLeft};
	padding-bottom: ${props => props.paddingBottom};
	border-top: ${props => props.borderTop};
	border-left: ${props => props.borderLeft};
	font-size: ${props => props.fontSize};
	font-weight: ${props => props.fontWeight};
	text-align: ${props => props.textAlign};
	line-height: ${props => props.lineHeight};
	color: ${props => props.color};
	cursor: ${props => props.cursor};
	width: ${props => props.width};
	min-width: ${props => props.minWidth};
	max-width: ${props => props.maxWidth};
	height: ${props => props.height};
	overflow: ${props => props.overflow};
	opacity: ${props => props.opacity};
	white-space: ${props => props.whiteSpace};
`;

export const ShadowBox = styled.div`
	background: ${props => props.background};
	background-color: ${props => props.backgroundColor || colors.white};
	width: ${props => props.width};
	min-width: ${props => props.minWidth};
	border: ${props => props.border};
	box-shadow: ${props => props.shadow || shadows.small};
	border-radius: ${props => props.borderRadius};
	font-size: ${props => props.fontSize};
	font-weight: ${props => props.fontWeight};
	margin-top: ${props => props.marginTop};
	margin-bottom: ${props => props.marginBottom};
	min-height: ${props => props.minHeight};
	position: ${props => props.position};
	padding: ${props => props.padding};
	padding-top: ${props => props.paddingTop};
	padding-bottom: ${props => props.paddingBottom};
	padding-left: ${props => props.paddingLeft};
	padding-right: ${props => props.paddingRight};
	color: ${props => props.color};
	text-align: ${props => props.textAlign};
`;

export const Paragraph = styled.p`
	font-size: ${props => props.fontSize || fontSizes[6]};
	font-weight: ${props => props.fontWeight};
	color: ${props => props.color};
	background-color: ${props => props.backgroundColor};
	border-radius: ${props => props.borderRadius};
	margin: ${props => props.margin};
	margin-top: ${props => props.marginTop};
	margin-bottom: ${props => props.marginBottom};
	padding-left: ${props => props.pl};
	padding-top: ${props => props.pt};
	padding-bottom: ${props => props.pb};
	padding-right: ${props => props.pr};
	text-align: ${props => props.textAlign};
	max-width: ${props => props.maxWidth};
	width: ${props => props.width};
`;

export const Heading = styled.h1`
	font-size: ${props => props.fontSize};
	font-weight: ${props => props.fontWeight};
	letter-spacing: ${props => props.letterSpacing};
	color: ${props => props.color};
	margin-bottom: ${props => props.mb};
	text-align: ${props => props.textAlign};
`;

export const SubHeading = styled.h2`
	font-size: ${props => props.fontSize};
	font-weight: ${props => props.fontWeight};
	color: ${props => props.color};
`;

export const Span = styled.span`
	font-size: ${props => props.fontSize};
	font-weight: ${props => props.fontWeight};
	line-height: ${props => props.lineHeight};
	width: ${props => props.width};
	color: ${props => props.color};
	background-color: ${props => props.backgroundColor};
	cursor: ${props => props.cursor};
	border-radius: ${props => props.borderRadius};
	margin: ${props => props.margin};
	margin-top: ${props => props.marginTop};
	margin-right: ${props => props.marginRight};
	margin-bottom: ${props => props.marginBottom};
	margin-left: ${props => props.marginLeft};
	padding: ${props => props.padding};
	padding-left: ${props => props.paddingLeft};
	padding-top: ${props => props.paddingTop};
	padding-bottom: ${props => props.paddingBottom};
	padding-right: ${props => props.paddingRight};
	white-space: ${props => props.whiteSpace};
	align-self: ${props => props.alignSelf};
	display: ${props => props.display};
	text-decoration: ${props => props.textDecoration};
	flex: ${props => props.flex};
	word-break: ${props => props.wordBreak};
`;

export const FourthLevelHeading = styled.h4`
	margin: 5px 0;
`;

export const StyledLabel = styled.h4`
	display: ${props => props.display};
	margin: ${props => props.margin || 0};
	margin-top: ${props => props.marginTop};
	margin-right: ${props => props.marginRight};
	margin-bottom: ${props => props.marginBottom};
	font-weight: ${props => props.fontWeight || 400};
	white-space: ${props => props.whiteSpace};
`;

export const Image = styled.img`
	width: ${props => props.width};
	height: ${props => props.height};
	filter: ${props => props.filter};
	image-rendering: ${props => props.imageRendering};
	margin-top: ${props => props.marginTop};
	margin-bottom: ${props => props.marginBottom};
`;

export const HyperLink = styled.a`
	color: ${props => props.color};
	font-size: ${props => props.fontSize};
	font-weight: ${props => props.fontWeight};
	width: ${props => props.width};
	background-color: ${props => props.backgroundColor};
	border-radius: ${props => props.borderRadius};
	margin: ${props => props.margin};
	padding: ${props => props.padding};
	margin-right: ${props => props.marginRight};
	margin-bottom: ${props => props.marginBottom};
	display: ${props => props.display};
	flex-align: ${props => props.flexAlign};
`;

export const UnorderedList = styled.ul`
	width: ${props => props.width};
	white-space: ${props => props.whiteSpace};
	left: ${props => props.left};
`;

export const ListItem = styled.li`
	color: ${props => props.color};
	pointer-events: ${props => props.pointerEvents};
`;



// WEBPACK FOOTER //
// ./src/lib/StyledComponents.js